<tp-banner/>
@if (app.currentTeam$ | async) {
  <router-outlet/>
} @else {
  <tp-spinner/>
}
